export default __webpack_public_path__ + "static/media/login.e687cdc9.png";